import { styled } from '@linaria/react';
import { colors, layout, space } from '../../theme/tokens';

export const Track = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(calc(var(--gallery-index, 0) * -100%));
  transition: transform 0.35s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Slide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: ${space[4]};
  left: ${space[5]};
  right: ${space[5]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  @media (min-width: ${layout.desktopBreakpoint}) {
    bottom: ${space[6]};
    left: ${space[6]};
    right: ${space[6]};
  }
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  background: ${colors.white};
  border-radius: ${layout.borderRadiusFull};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
`;

export const Dot = styled.button`
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: ${layout.borderRadiusFull};
  background: ${colors.white};
  opacity: 0.5;
  cursor: pointer;
  transition: width 0.2s ease;

  &[data-active='true'] {
    width: 20px;
    opacity: 1;
  }
`;
